import classNames from 'classnames';
import React from 'react';

import { SWATCHES } from './../../../../color-picker/common/data-hooks';

import { AddColorButton } from '../add-color-button';
import { SingleColorSwatch } from '../single-color-swatch';
import classes from './new-color-swatches-scss';

interface NewColorSwatchesProps {
  colors: string[];
  selectedColor?: string | undefined;
  onAddClick?: () => void;
  onColorSelected: (color: string | undefined) => void;
  onColorPreviewStart?: (color: string | undefined) => void;
  onColorPreviewEnd?: () => void;
  dataHook?: string;
  setAddButtonRef?: (ref: HTMLDivElement) => void;
}

export const NewColorSwatches: React.FC<NewColorSwatchesProps> = ({
  colors,
  selectedColor,
  onAddClick,
  onColorSelected,
  onColorPreviewStart,
  onColorPreviewEnd,
  dataHook,
  setAddButtonRef,
}) => {
  return (
    <div data-hook={dataHook}>
      <div className={classNames(classes.container)} data-hook={SWATCHES}>
        {colors.map(color => (
          <SingleColorSwatch
            key={color}
            fill={color}
            selectedColor={selectedColor}
            onClick={onColorSelected}
            onMouseEnter={onColorPreviewStart}
            onMouseLeave={onColorPreviewEnd}
          />
        ))}
        {!!onAddClick && <AddColorButton onAddClick={onAddClick} setRef={setAddButtonRef} />}
      </div>
    </div>
  );
};
